import type { FC } from "react";
import useTranslation from "next-translate/useTranslation";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";
import commonStyles from "./ProfileHeader.module.scss";
import authenticatedStyles from "./ProfileHeaderAuthenticated.module.scss";
import classnames from "classnames";

export const ProfileHeaderAuthenticated: FC = () => {
  const { t } = useTranslation("web-payments");

  return (
    <header className={commonStyles.wrapper}>
      <ImageWithFallback
        className={commonStyles.iconContainer}
        width={48}
        height={48}
        fallbackImage={null}
        alt=""
        src="https://images.onefootball.com/cw/icons/profile-light.svg"
        darkModeSrc="https://images.onefootball.com/cw/icons/profile-dark.svg"
      />

      <p
        className={classnames(commonStyles.title, authenticatedStyles.welcome)}
      >
        {t`PROFILE_WELCOME`}
      </p>

      <p
        className={classnames(
          commonStyles.subtitle,
          authenticatedStyles.yourProfile,
        )}
      >{t`PROFILE_YOUR`}</p>
    </header>
  );
};
